@if (!startTrialMode()) {
  <div>
    <h2>{{ product().name }} Summary</h2>
    @if (pricingBoxContent()) {
      <div class="list no-hover main-product-features">
        @for (point of pricingBoxContent().content.points; track point) {
          <div
            class="list-item"
            [class.faded]="point.icon === 'cross'"
            appTooltip=""
            [tooltipHtmlContent]="point.tooltipContent | storyblokRichText"
            [showOnMobile]="true"
            [tooltipStyle]="'light'"
            [tooltipSize]="'big'"
            [skipDelay]="true"
          >
            <app-svg class="list-item-icon" src="/assets/icons/{{ point.icon }}.svg"></app-svg>
            <div [class.has-tooltip]="(point.tooltipContent | storyblokRichText).length > 10">
              {{ point.text }}
            </div>
            @if ((point.tooltipContent | storyblokRichText).length > 10) {
              <app-svg src="/assets/icons/16/info.svg" class="feature-info-icon"></app-svg>
            }
          </div>
        }
      </div>
    }
  </div>
} @else {
  <div class="trial-steps">
    <div class="trial-step">
      <div class="trial-step-bar">
        <div class="circled-icon"><img src="/assets/icons/special/lock-off-circle.svg" alt="" /></div>
        <div class="trial-step-dashes">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="trial-step-content">
        <h2>Today</h2>
        <p>Start your free trial and unlock all premium features.</p>
      </div>
    </div>
    <div class="trial-step">
      <div class="trial-step-bar">
        <app-svg src="/assets/icons/bell.svg"></app-svg>
        <div class="trial-step-dashes">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="trial-step-content">
        <h2>In {{ trialLengthDays() - 2 }} Days</h2>
        <p>We’ll send a reminder 2 days before your trial ends – no surprises!</p>
      </div>
    </div>
    <div class="trial-step">
      <div class="trial-step-bar">
        <app-svg src="/assets/icons/check-circle.svg"></app-svg>
        <div class="trial-step-gradient"></div>
      </div>
      <div class="trial-step-content">
        <h2>In {{ trialLengthDays() }} Days</h2>
        <p>Your subscription starts, unless you cancel anytime before {{ trialEndDate() | date: 'MMMM d' }}.</p>
      </div>
    </div>
  </div>
}
